import { useInfiniteQuery, useQuery } from 'react-query';
import {
  WorkOrderKitDetailRequest,
  WorkOrderKitListRequest,
} from './Kits.types';
import KitsServices from './Kits.services';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import notificationError from '@/utils/functions/notificationError';

export function useWorkOrderKitList(
  params?: WorkOrderKitListRequest,
  enabled = true,
) {
  return useInfiniteQuery(
    ['workorder/kit/list', { ...params }],
    ({ pageParam }) => {
      const req: WorkOrderKitListRequest = {
        nextToken: pageParam,
        order: (params?.order || DEFAULT_ORDER) === 'ASC' ? 1 : 0,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return KitsServices.list(req);
    },
    {
      enabled,
      getNextPageParam: (lastPage) => lastPage.nextToken,
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function useWorkOrderKitDetail(params: WorkOrderKitDetailRequest) {
  return useQuery(
    ['workorder/kit/detail', { ...params }],
    () => KitsServices.detail(params),
    {
      enabled: !!params.kitId,
      onError(err) {
        notificationError(err);
      },
    },
  );
}
